import { IContextFileEntry } from '../Types/clientCreate';
import {
  ICampaignCreatePayload,
  ICreateCampaignRequest,
} from '../Types/campaignCreate';
import {
  buildFileMetadata,
  formatCreateClientApiError,
  hasBackgroundSource,
  hasFilesWithoutScopes,
  MAX_CLIENT_CONTEXT_FILES,
} from './createClientHelpers';

export function buildCampaignCreatePayload(
  clientId: string,
  request: ICreateCampaignRequest
): ICampaignCreatePayload {
  const payload: ICampaignCreatePayload = {
    name: request.name.trim(),
    client_id: clientId,
  };

  const backgroundText = request.backgroundText?.trim() ?? '';
  if (backgroundText) {
    payload.background_text = backgroundText;
  }

  const generationFocus = request.campaignGenerationFocus?.trim() ?? '';
  if (generationFocus) {
    payload.campaign_generation_focus = generationFocus;
  }

  return payload;
}

export interface CreateCampaignFormErrors {
  client?: string;
  name?: string;
  background?: string;
  files?: string;
  submit?: string;
}

export function validateCreateCampaignForm(
  clientId: string | null,
  name: string,
  backgroundText: string,
  files: IContextFileEntry[]
): CreateCampaignFormErrors {
  const errors: CreateCampaignFormErrors = {};

  if (!clientId) {
    errors.client = 'Choose an organization for this campaign';
  }

  if (!name.trim()) {
    errors.name = 'Campaign name is required';
  }

  if (!hasBackgroundSource(backgroundText, files)) {
    errors.background =
      'Provide campaign background text and/or at least one background file.';
  }

  if (hasFilesWithoutScopes(files)) {
    errors.files = 'Each uploaded file must have at least one purpose selected.';
  }

  if (files.length > MAX_CLIENT_CONTEXT_FILES) {
    errors.files = `At most ${MAX_CLIENT_CONTEXT_FILES} files are allowed`;
  }

  return errors;
}

export function formatCreateCampaignApiError(error: unknown): string {
  const message = formatCreateClientApiError(error);
  if (message === 'Failed to create client. Please try again.') {
    return 'Failed to create campaign. Please try again.';
  }
  return message;
}

export { buildFileMetadata };
